<template>
  <div class="usp-container">
    <!-- Карточка USP -->
    <div class="data-section usp-card">
      <div class="d-flex justify-content-end align-items-center mb-3">
        <download-button
          :downloadReportType="downloadReportType"
          :urls="[uspDownloadLink]"
          class="align-to-right"
          :disabled="!hasData"
          :title="hasData ? 'Скачать отчет USP' : 'Нет данных для скачивания'"
        ></download-button>
      </div>

      <div class="usp__filters d-flex mb-3">
        <div class="usp__filter">
          <input
            type="radio"
            id="title"
            value="is_title"
            v-model="uspTypeModel"
          />
          <label for="title">Заголовки</label>
        </div>
        <div class="usp__filter">
          <input
            type="radio"
            id="content"
            value="is_content"
            v-model="uspTypeModel"
          />
          <label for="content">Тексты</label>
        </div>
        <div class="usp__filter">
          <input
            type="radio"
            id="quick_links"
            value="is_quick_links_title"
            v-model="uspTypeModel"
          />
          <label for="quick_links">Быстрые ссылки</label>
        </div>
      </div>

      <div class="usp_cols row justify-content-start">
        <usp-result
          v-for="i in uspListsLength"
          :key="i - 1"
          :usp-list-id="i - 1"
          :class="['usp__list', 'col-4', { 'usp__list--left': i === 1 }]"
        ></usp-result>
      </div>
    </div>
  </div>
</template>
<script>
import ResultsTable from "../positions/reports/TableResults";
import EventHubListenerMixin from "../common/mixins/EventHubListener";
import DownloadButton from "../common/DownloadButton";
import UspResult from "./UspResult";

import ChartAPI from "../common/chart-api";
import Multiselect from "vue-multiselect";
import {mapActions, mapGetters} from "vuex";

const axios = require("axios").default;

export default {
  components: {
    ResultsTable,
    EventHubListenerMixin,
    Multiselect,
    DownloadButton,
    UspResult,
  },

  data() {
    let saved_data =
      JSON.parse(window.localStorage.getItem("form_data")) ||
      JSON.parse(window.sessionStorage.getItem("form_data")) ||
      {};
    return {
      studObj: new ChartAPI(),
      datacollection: [],
      options: [],
      header: "Ститистика по ключевым словам",
      loaded: false,
      setIntervalId: null,
      ourLabels: "There are no active advertisers",
      events: ["updateData"],
      items: [],
      competitors_usp: [],
      currentProject: saved_data.currentProject || null,
      showLoading: false,
      errorMessage: "",
      results_in_top_filter_options_value: {
        title: "Больше",
        value: "results_in_top_gte",
      },
      results_in_top_filter_value: null,
      dataToExport: [],
      kw_types: {},

      usp_type: "title",
      selectedAdvertiser: null,
      selectedCompetitor: null,
      downloadReportType: "export-usp",
    };
  },
  computed: {
    ...mapGetters("usp", ["uspType", "uspListsLength", "uspLists"]),
    ...mapGetters("filters", ["resultsPeriod"]),
    uspTypeModel: {
      get() {
        return this.uspType;
      },
      set(val) {
        this.selectUspType(val);
      },
    },
    period() {
      if (this.resultsPeriod) {
        return `за период ${this.resultsPeriod}`;
      }
    },
    hasData() {
      // Проверяем, есть ли данные в USP списках
      if (!this.uspLists || this.uspLists.length === 0) {
        return false;
      }

      // Проверяем, что хотя бы один список имеет данные
      return this.uspLists.some(list =>
        list && list.items && list.items.length > 0
      );
    },
    uspDownloadLink() {
      // Формируем ссылку для скачивания на основе текущих фильтров
      let link = this.uspDownloadLinkBase;
      if (this.uspType) {
        link += `&${this.uspType}=true`;
      }
      return link;
    },
    uspDownloadLinkBase() {
      // Базовая ссылка для скачивания USP
      return this.$store.getters["usp/uspDownloadLink"];
    },
  },

  mounted() {
    // При входе на УТП: сброс рекламодателей и данных, по умолчанию только Desktop
    this.$store.commit("usp/resetUspSelections");
    this.$store.commit("filters/updateDeviceTypes", ["desktop"]);
  },
  beforeDestroy() {
    // При уходе с USP возвращаем оба варианта устройств для остальных страниц (Реклама и т.д.)
    this.$store.commit("filters/updateDeviceTypes", ["desktop", "mobile"]);
  },
  methods: {
    ...mapActions("usp", ["selectUspType"]),
    renderHeader(text) {
      return `${text}`;
    },
  },
};
</script>
<style></style>
